module.exports = __webpack_public_path__ + "img/balkonverkleidung02.41f675a9.jpg";